import { AppMetaData } from 'mytours-read-common'

// Whether the Profile tab is shown (vs falling back to Settings): badges-on-profile (when
// badge-linked) or favourites enabled. Also decides where Purchased Content renders.
export const isProfileTabShown = (appMetaData?: AppMetaData): boolean =>
	Boolean((appMetaData?.badge_linked && appMetaData?.badges_on_profile_enabled) || appMetaData?.favorites_enabled)
